import {GroupedProductSelectorCards, LegoBaseTheme} from '@mfb/lego';
import * as React from 'react';
import styled from 'styled-components';
import {getImageModel} from '../../contentful/asset/AssetContentModel';
import {getColor} from '../../contentful/color/ColorContentModel';
import {
  GroupedProductSelectorContentModel,
  ProductSelectorContentModel,
} from '../../contentful/productSelectorTabSet/ProductSelectorTabSetContentModel';

const StyledGroupedProductSelectorCards = styled(GroupedProductSelectorCards)`
  padding: 48px 70px 0;

  @media ${LegoBaseTheme.layout.deviceMediaQueries.max.lg} {
    padding: 16px 16px 0;
  }
`;

export interface ProductSelectorGroupCardsProps {
  groupedEntry: GroupedProductSelectorContentModel;
  selectedSelector?: ProductSelectorContentModel;
  onSelect: (selector: ProductSelectorContentModel) => void;
}

const ProductSelectorGroupCards = ({
  groupedEntry,
  selectedSelector,
  onSelect,
}: ProductSelectorGroupCardsProps) => {
  const selectors = groupedEntry.productSelectors ?? [];

  return (
    <StyledGroupedProductSelectorCards
      options={selectors.map(selector => {
        const icon = getImageModel(selector.groupedSelectorIcon);
        return {
          id: selector.id,
          heading: selector.groupedSelectorHeading ?? '',
          subHeading: selector.groupedSelectorSubHeading,
          badge: selector.groupedSelectorBadge,
          badgeColor: getColor(selector.groupedSelectorBadgeColour),
          iconSrc: icon?.src,
          iconAlt: icon?.alt,
        };
      })}
      selectedOptionId={selectedSelector?.id}
      onSelect={option => {
        if (option.id === selectedSelector?.id) {
          return;
        }
        const selector = selectors.find(s => s.id === option.id);
        if (selector) {
          onSelect(selector);
        }
      }}
    />
  );
};

export default ProductSelectorGroupCards;
